import React from "react";
import { ExpendableLink } from "./expendable-link";
import { Crosshair, Package, ScanSearch } from "lucide-react";

export const ClientMenu: React.FC = () => {
  return (
    <>
      <ExpendableLink
        title="Cibles"
        url="/sites"
        icon={<Crosshair size={14} />}
      />
      <ExpendableLink
        title="Analyses"
        url="/scans"
        icon={<ScanSearch size={14} />}
      />
      <ExpendableLink
        title="Produits"
        url="/products"
        icon={<Package size={14} />}
      />
    </>
  );
};
